var _defs, _path, _path2, _line, _line2, _line3, _path3, _path4, _path5, _path6, _line4, _path7, _line5, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _circle2, _path29, _path30, _line6, _path31, _line7, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8f4fa;}.cls-2{fill:#fff;}.cls-10,.cls-13,.cls-17,.cls-3{fill:none;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-16,.cls-17,.cls-18,.cls-19,.cls-3,.cls-6,.cls-8{stroke:#45413c;}.cls-13,.cls-16,.cls-18,.cls-19,.cls-3,.cls-6{stroke-linecap:round;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-16,.cls-18,.cls-19,.cls-3,.cls-6,.cls-8{stroke-linejoin:round;}.cls-11,.cls-4{fill:#656769;}.cls-5,.cls-8{fill:#87898c;}.cls-20,.cls-6{fill:#ffcebf;}.cls-7{fill:#020202;opacity:0.15;}.cls-18,.cls-9{fill:#525252;}.cls-12{fill:#ff6242;}.cls-13{stroke:#fff;}.cls-14,.cls-16{fill:#ffe500;}.cls-15{fill:#45413c;}.cls-17{stroke-miterlimit:10;}.cls-19{fill:#009fd9;}.cls-21{fill:#ffb59e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hacker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,50A40,40,0,1,0,13.56,66.5H86.44A39.85,39.85,0,0,0,90,50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.56,66.5a40,40,0,0,0,72.88,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11,
    y1: 66.5,
    x2: 89,
    y2: 66.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.5,
    y1: 66.5,
    x2: 9,
    y2: 66.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 91,
    y1: 66.5,
    x2: 93.5,
    y2: 66.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.5,59a15.5,15.5,0,0,0-31,0v7.5h25a2.5,2.5,0,0,1-2.45,2H61v6h4A8.51,8.51,0,0,0,73.5,66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58,43.5A15.5,15.5,0,0,0,42.5,59v4.5a15.5,15.5,0,0,1,31,0V59A15.5,15.5,0,0,0,58,43.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.5,59a15.5,15.5,0,0,0-31,0v7.5h25a2.5,2.5,0,0,1-2.45,2H61v6h4A8.51,8.51,0,0,0,73.5,66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65,68.5A2.5,2.5,0,0,0,67.5,66V57.5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58,
    y1: 58.5,
    x2: 58,
    y2: 66.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61,68.51H57.5a3,3,0,0,0-3,3h0a3,3,0,0,0,3,3H61Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 61,
    y1: 74.51,
    x2: 61,
    y2: 68.51
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M24.5,76c0,.83,9.45,1.5,21.1,1.5s21.1-.67,21.1-1.5-9.44-1.5-21.1-1.5S24.5,75.18,24.5,76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.28,71.5h2.35L47,54.32a1.18,1.18,0,0,0-1.12-.82H44.42Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.42,71.5H50.28l-5.86-18H23.17a1.17,1.17,0,0,0-1,.49,1.15,1.15,0,0,0-.16,1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.42,53.5H23.17a1.17,1.17,0,0,0-1,.49,1.15,1.15,0,0,0-.16,1l.34,1.05H45.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.42,71.5H50.28l-5.86-18H23.17a1.17,1.17,0,0,0-1,.49,1.15,1.15,0,0,0-.16,1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.5,71.5h24v3H29.81a2.32,2.32,0,0,1-2.31-2.34Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.5,71.5H63v.66a2.35,2.35,0,0,1-2.35,2.34H51.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.42,71.5H50.28l-5.86-18H23.17a1.17,1.17,0,0,0-1,.49,1.15,1.15,0,0,0-.16,1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M38.91,61.34c.14-.5.74-.49,1.08,0L41.82,64c.73,1.06,1.1,1.58,1.84,2.63.34.49.17,1.11-.32,1.11H38.19a.92.92,0,0,1-.78-1.11c.31-1.06.45-1.58.75-2.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.84,63.22c.12.6.18.9.31,1.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.88,66.21c.06.28-.09.5-.32.5a.6.6,0,0,1-.53-.5c-.05-.27.09-.5.32-.5A.61.61,0,0,1,40.88,66.21Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M33.91,61.37c.42,2.07-.66,3.75-2.41,3.75s-3.5-1.69-3.91-3.77.66-3.75,2.4-3.74S33.49,59.3,33.91,61.37Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M29.4,59.89c-.23,0-.37.22-.32.5a.61.61,0,0,0,.52.5c.23,0,.38-.22.32-.5a.59.59,0,0,0-.52-.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M30,62.61a1.39,1.39,0,0,0,1.16.88.84.84,0,0,0,.82-.87"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M28.1,58.54l5.35,1.52"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M31.62,59.36h-.44c-.34,0-.55.33-.47.74l.1.52a.89.89,0,0,0,.78.74H32c.35,0,.56-.33.48-.74l-.11-.52a.91.91,0,0,0-.77-.75Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M58,43.5a15.43,15.43,0,0,1,9.88,3.56A14.15,14.15,0,0,0,70,39.56V27.5a12,12,0,0,0-24,0V39.56a14.15,14.15,0,0,0,2.12,7.5A15.43,15.43,0,0,1,58,43.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M58,43.5a15.51,15.51,0,0,0-8,2.23c.1.34.21.66.33,1a18.11,18.11,0,0,0,3.86,5.79c2.48,3,3.24,3,3.83,6,.59-3,1.35-3,3.83-6a18.11,18.11,0,0,0,3.86-5.79c.12-.31.23-.63.33-1A15.51,15.51,0,0,0,58,43.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M61.5,46a5,5,0,0,1-7,0V40.5h7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M54.5,44a12,12,0,0,0,7,0V40.5h-7Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.5,40.5V46a5,5,0,0,1-7,0V40.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68,30V27.5a10,10,0,0,0-20,0V30a2,2,0,0,0,0,4h.12a10,10,0,0,0,19.76,0H68a2,2,0,0,0,0-4Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M68,30V27.5a10,10,0,0,0-20,0V30a2,2,0,0,0,0,4h.12a10.56,10.56,0,0,0,.47,1.86c.63-4.15,4.6-7.35,9.41-7.35s8.78,3.2,9.41,7.35A10.56,10.56,0,0,0,67.88,34H68a2,2,0,0,0,0-4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 52.25,
    cy: 34.25,
    r: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 63.75,
    cy: 34.25,
    r: 1.25
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55,36.79a4.38,4.38,0,0,0,6,0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68,30V27.5a10,10,0,0,0-20,0V30a2,2,0,0,0,0,4h.12a10,10,0,0,0,19.76,0H68a2,2,0,0,0,0-4Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.49,
    y1: 30.5,
    x2: 53,
    y2: 29
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M54,31a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.51,
    y1: 30.5,
    x2: 63,
    y2: 29
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M62,31a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58,26.5c-7,0-9,5-9,8.16,0,4.51.11,8.89,1.31,12a18.41,18.41,0,0,0,3.86,5.79A14.29,14.29,0,0,1,46,39.56V27.5a12,12,0,0,1,24,0V39.56a14.29,14.29,0,0,1-8.17,12.93,18.41,18.41,0,0,0,3.86-5.79c1.2-3.15,1.31-7.53,1.31-12C67,31.5,65,26.5,58,26.5Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58,15.5a12,12,0,0,0-12,12V31a12,12,0,0,1,24,0V27.5A12,12,0,0,0,58,15.5Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58,26.5c-7,0-9,5-9,8.16,0,4.51.11,8.89,1.31,12a18.41,18.41,0,0,0,3.86,5.79A14.29,14.29,0,0,1,46,39.56V27.5a12,12,0,0,1,24,0V39.56a14.29,14.29,0,0,1-8.17,12.93,18.41,18.41,0,0,0,3.86-5.79c1.2-3.15,1.31-7.53,1.31-12C67,31.5,65,26.5,58,26.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9de4df48f9e4a940cc8f21d5cfa1cd12.svg";
export { ForwardRef as ReactComponent };